import { GET_ID_INDIVIDUAL_CLEAR_VERFIDATION_URL, GET_ID_INDIVIDUAL_VERFICATION_URL, GET_INDIVIDUAL_LIST } from "../../../config/adminUrlConfig";
import { ApiService } from "../../../config/apiServices";


export const getIndividaulList = (perPage,currentPage,selectedStatus,searchData,selectedDistrictId,selectedCategory,selectedSubCategoryId,selectedSportId,selectedInsitutionCategoryId,orgselectedCategory,selectedGender) => {
    return ApiService.get(`${GET_INDIVIDUAL_LIST}?number=${perPage}&page=${currentPage}&status=${selectedStatus}&search=${searchData}&city=${selectedDistrictId}&category_type=${selectedCategory}&sub_category_type=${selectedSubCategoryId}&sport_id=${selectedSportId}&org_id=${selectedInsitutionCategoryId}&org_type=${orgselectedCategory}&gender=${selectedGender}`);
};

export const getAllDataIndividaulList = () => {
    return ApiService.get(GET_INDIVIDUAL_LIST);
};
export const getIndividualVerfiedByID = (Id) => {
    return ApiService.get(`${GET_ID_INDIVIDUAL_VERFICATION_URL}${Id}`);
}


export const clearIndividualVerfication = (data) => {
    return ApiService.post(GET_ID_INDIVIDUAL_CLEAR_VERFIDATION_URL,data);
};